import { useGetSpecialIntegrationKeysQuery } from '@app/store/api/intergation-settings.api';
import { Button, EasyModal } from '@ui';
import React, { useState } from 'react';

import useTranslation from '@app/hooks/use-translation';

import RubberTable from '@app/components/rubber-table';

import { TableColumn } from '@app/components/rubber-table/table.types';

import SpecialIntegrationForm from './special-integration-form';
const SpecialIntegration = () => {
  const { t: integ_t } = useTranslation('pages.settings.integrations.special_integration');

  const [formModalState, changeFormModalState] = useState(false);
  const { data } = useGetSpecialIntegrationKeysQuery();

  function onCloseModal() {
    changeFormModalState(false);
  }
  const columns: TableColumn[] = [
    {
      index: 'key',
      title: integ_t('key_label'),
    },
    {
      index: 'value',
      title: integ_t('value_label'),
    },
    {
      index: 'description',
      title: integ_t('description_label'),
    },
  ];
  return (
    <div className="pb-[20px]">
      <div className="flex items-center w-full justify-between py-[30px]">
        <h1 className="text-[18px] font-[700] ml-[20px]">{integ_t('title')}</h1>
        <div>
          <Button
            icon="CirclePlusIcon"
            label={
              (data?.afields?.length || 0) >= 1 ? integ_t('edit_button') : integ_t('add_button')
            }
            onClick={() => changeFormModalState(true)}
          />
        </div>
      </div>
      <RubberTable columns={columns} dataSource={data?.afields || []} />
      <EasyModal
        label={integ_t('modal_label')}
        withoutFooter
        show={formModalState}
        onClose={onCloseModal}
      >
        {formModalState && <SpecialIntegrationForm defaultValues={data} onClose={onCloseModal} />}
      </EasyModal>
    </div>
  );
};

export default SpecialIntegration;
